import React from 'react';

import {
	useClassNames,
} from '@common';

import './DefaultTd.scss';

interface DefaultTdProps extends React.ThHTMLAttributes<HTMLTableHeaderCellElement> {
	test?: unknown,
}

function DefaultTd(props: DefaultTdProps): JSX.Element {
	const {
		children,
		className,
		...tdProps
	} = props;

	const classes = useClassNames('table__cell', className);

	return (
		<td className={classes} {...tdProps}>
			{children}
		</td>
	);
}

const MemoisedDefaultTd = React.memo(DefaultTd);

export {MemoisedDefaultTd as DefaultTd};